import { Component, effect, input, output, signal } from '@angular/core';
import {
  GcButtonComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { InstallationReportOverview } from '../../../../entities/installation-reporting-mdu-details.entities';
import { BomCommentCardComponent } from '../bom-comment-card/bom-comment-card.component';
import { BomCommentFormComponent } from '../bom-comment-form/bom-comment-form.component';

@Component({
  selector: 'app-delivery-point-bom',
  imports: [
    GcButtonComponent,
    IpoTranslatePipe,
    BomCommentCardComponent,
    BomCommentFormComponent,
  ],
  templateUrl: './delivery-point-bom.component.html',
  styleUrl: './delivery-point-bom.component.scss',
})
export class DeliveryPointBomComponent {
  overview = input<InstallationReportOverview | null>(null);
  isBom = input(false);
  isSaving = input(false);

  bomMarked = output<string>();

  readonly isFormOpen = signal(false);

  constructor() {
    effect(() => {
      this.initFormState();
    });
  }

  openForm(): void {
    this.isFormOpen.set(true);
  }

  closeForm(): void {
    this.isFormOpen.set(false);
  }

  private initFormState(): void {
    if (this.isBom()) {
      this.isFormOpen.set(false);
    }
  }
}
